import { DataSource, Layout, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutARCallHistory extends Layout {
    panelCallHistory: Panel;
    searchpanelCallHistory: SearchPanel;
    sourceArCallHistory: DataSource;
    tableCallHistory: Table;
    textboxCallDate: Textbox;
    textboxCallerUserIdSearch: Textbox;
    textboxCollectionsId: Textbox;
    textboxCustomerId: Textbox;
    textboxInvoiceNoString: Textbox;
    textboxOrderId: Textbox;
    textboxReferenceNumber: Textbox;
}
